/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ConversionStatistics,
    ConversionStatisticsFromJSON,
    ConversionStatisticsFromJSONTyped,
    ConversionStatisticsToJSON,
} from './ConversionStatistics';

/**
 * 
 * @export
 * @interface ConversionStatisticsResponse
 */
export interface ConversionStatisticsResponse {
    /**
     * 
     * @type {Array<ConversionStatistics>}
     * @memberof ConversionStatisticsResponse
     */
    items: Array<ConversionStatistics>;
}

export function ConversionStatisticsResponseFromJSON(json: any): ConversionStatisticsResponse {
    return ConversionStatisticsResponseFromJSONTyped(json, false);
}

export function ConversionStatisticsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConversionStatisticsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ConversionStatisticsFromJSON)),
    };
}

export function ConversionStatisticsResponseToJSON(value?: ConversionStatisticsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(ConversionStatisticsToJSON)),
    };
}

